export const text = {
  header: "Files",
};
